// extracted by mini-css-extract-plugin
export var imageRow = "RichTextGallery-module--image-row--e1a63";
export var imageRow2Up = "RichTextGallery-module--image-row2-up--1a551";
export var imageRow3Up = "RichTextGallery-module--image-row3-up--add05";
export var imageRow4Up = "RichTextGallery-module--image-row4-up--10ec9";